/**
 * Quick Add Modal — Standalone JS (no OLD dependencies)
 * Uses native <dialog> with overlay-drawer pattern
 */
(function () {
  'use strict';

  if (window.__quickAddModalInit) return;
  window.__quickAddModalInit = true;

  var activeModal = null;
  var previousFocus = null;
  var CLOSE_DURATION = 300;
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var savedScrollY = 0;

  /* --- iOS-safe scroll lock --- */
  function lockScroll() {
    savedScrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + savedScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.overflow = 'hidden';
  }

  function unlockScroll() {
    var scrollY = savedScrollY;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.overflow = '';
    window.scrollTo(0, scrollY);
  }

  /* =====================
     Shopify money format
     ===================== */
  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat);
    }
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return amount + ' \u20AC';
  }

  /* =====================
     Toast notification
     ===================== */
  function showToast(message, isError) {
    var toast = document.createElement('div');
    toast.className = 'quick-add-toast' + (isError ? ' quick-add-toast--error' : '');
    toast.textContent = message;
    document.body.appendChild(toast);
    setTimeout(function () {
      if (toast.parentNode) toast.parentNode.removeChild(toast);
    }, 2600);
  }

  /* Textes traduits exposés par snippets/js-variables.liquid (fallback FR) */
  var STRINGS = (window.themeVariables && window.themeVariables.strings) || {};
  var TOAST_ADDED = STRINGS.toastAddedToCart || 'Ajouté au panier';
  var TOAST_ADD_ERROR = STRINGS.toastAddError || 'Erreur lors de l’ajout';

  function limitReachedMessage(limit) {
    return (STRINGS.toastLimitReached || 'Limite d’achat atteinte ([limit] max)').replace('[limit]', limit);
  }

  /* =====================
     Cart API helpers
     ===================== */
  function getCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (res) { return res.json(); });
  }

  function getCartQuantityForVariant(cart, variantId) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id === variantId) {
        return cart.items[i].quantity;
      }
    }
    return 0;
  }

  function getCartQuantityForProduct(cart, productId) {
    var total = 0;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].product_id === productId) {
        total += cart.items[i].quantity;
      }
    }
    return total;
  }

  function addToCart(variantId, quantity) {
    // URL localisée : les messages d'erreur de l'API panier sont renvoyés dans la langue courante
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    }).then(function (res) {
      if (!res.ok) {
        return res.json().then(function (data) {
          throw new Error(data.description || data.message || TOAST_ADD_ERROR);
        });
      }
      return res.json();
    });
  }

  function notifyCartChange() {
    document.dispatchEvent(new CustomEvent('cart:change'));
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }

  /* =====================
     Stock check helpers
     ===================== */
  /* =====================
     Direct add (mono-variant)
     ===================== */
  function handleDirectAdd(btn) {
    var variantId = parseInt(btn.getAttribute('data-quick-add-variant-id'), 10);
    var productId = parseInt(btn.getAttribute('data-product-id'), 10) || 0;
    if (!variantId || btn.classList.contains('is-loading') || btn.classList.contains('is-added')) return;

    var buyLimitRaw = btn.getAttribute('data-buy-limit');
    var buyLimit = buyLimitRaw ? parseInt(buyLimitRaw, 10) : 0;

    btn.classList.add('is-loading');

    if (!buyLimit) {
      doDirectAdd(btn, variantId);
      return;
    }

    // Check cart for buy-limit only
    getCart().then(function (cart) {
      var inCartProduct = productId ? getCartQuantityForProduct(cart, productId) : getCartQuantityForVariant(cart, variantId);
      var maxAddable = buyLimit - inCartProduct;

      if (maxAddable <= 0) {
        btn.classList.remove('is-loading');
        showToast(limitReachedMessage(buyLimit), true);
        return;
      }

      doDirectAdd(btn, variantId);
    }).catch(function () {
      doDirectAdd(btn, variantId);
    });
  }

  function doDirectAdd(btn, variantId) {
    addToCart(variantId)
      .then(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        notifyCartChange();
        showToast(TOAST_ADDED + ' \u2713');

        setTimeout(function () {
          btn.classList.remove('is-added');
        }, 2000);
      })
      .catch(function (err) {
        btn.classList.remove('is-loading');
        showToast(err.message || TOAST_ADD_ERROR, true);
      });
  }

  /* =====================
     Modal: open
     ===================== */
  function openModal(btn) {
    var productId = btn.getAttribute('data-quick-add-product-id');
    if (!productId) return;

    var template = document.querySelector('template[data-quick-add-template="' + productId + '"]');
    var dataScript = document.querySelector('script[data-quick-add-variants="' + productId + '"]');
    if (!template || !dataScript) return;

    var data;
    try {
      data = JSON.parse(dataScript.textContent);
    } catch (e) {
      return;
    }

    // Clone template and add to body
    var clone = template.content.cloneNode(true);
    document.body.appendChild(clone);

    var dialog = document.body.querySelector('dialog[data-quick-add-modal]:last-of-type');
    if (!dialog) return;

    activeModal = {
      el: dialog,
      data: data,
      selectedOptions: []
    };

    // Initialize selected options from first available variant
    var firstAvailable = null;
    for (var i = 0; i < data.product.variants.length; i++) {
      if (data.product.variants[i].available) {
        firstAvailable = data.product.variants[i];
        break;
      }
    }
    if (!firstAvailable) firstAvailable = data.product.variants[0];

    activeModal.selectedOptions = firstAvailable.options.slice();

    // Mark correct options as selected
    updateOptionSelection();
    updateVariantState();

    // Focus management
    previousFocus = document.activeElement;
    btn.setAttribute('aria-expanded', 'true');
    activeModal.triggerBtn = btn;

    // Force reflow so the browser paints the off-screen state
    // before showModal() triggers the [open] animation
    dialog.offsetHeight;

    // Open the dialog
    dialog.showModal();

    // Prevent page scrolling behind the overlay (iOS-safe)
    lockScroll();

    // Focus first interactive element
    requestAnimationFrame(function () {
      var firstFocusable = dialog.querySelector('.overlay-drawer__close');
      if (firstFocusable) firstFocusable.focus();
    });

    // Notify other components
    document.dispatchEvent(new CustomEvent('quickadd:open'));
  }

  /* =====================
     Modal: close (animated)
     ===================== */
  function closeModal() {
    if (!activeModal) return;

    var dialog = activeModal.el;
    var triggerBtn = activeModal.triggerBtn;
    var modal = activeModal;
    activeModal = null;

    if (prefersReducedMotion) {
      dialog.close();
      cleanupDialog(dialog, triggerBtn);
      return;
    }

    // Animated close: set data-closing, wait for animation, then close
    dialog.setAttribute('data-closing', '');

    setTimeout(function () {
      dialog.close();
      cleanupDialog(dialog, triggerBtn);
    }, CLOSE_DURATION);
  }

  function cleanupDialog(dialog, triggerBtn) {
    unlockScroll();
    if (dialog.parentNode) dialog.parentNode.removeChild(dialog);

    if (triggerBtn) {
      triggerBtn.setAttribute('aria-expanded', 'false');
    }
    if (previousFocus) {
      previousFocus.focus();
    }

    document.dispatchEvent(new CustomEvent('quickadd:close'));
  }

  /* =====================
     Option selection
     ===================== */
  function handleOptionClick(btn) {
    if (!activeModal || btn.classList.contains('is-disabled')) return;

    var optionIndex = parseInt(btn.getAttribute('data-option-index'), 10);
    var optionValue = btn.getAttribute('data-option-value');

    activeModal.selectedOptions[optionIndex] = optionValue;

    // If clicking an unsellable option, auto-resolve to the closest available variant
    if (btn.classList.contains('is-unsellable')) {
      resolveClosestVariant(optionIndex, optionValue);
    }

    updateOptionSelection();
    updateVariantState();
  }

  /**
   * When clicking an unsellable option, find the available variant that
   * keeps the clicked option and matches as many other current selections as possible.
   */
  function resolveClosestVariant(lockedIndex, lockedValue) {
    if (!activeModal) return;

    var variants = activeModal.data.product.variants;
    var currentOptions = activeModal.selectedOptions;
    var bestVariant = null;
    var bestScore = -1;

    for (var v = 0; v < variants.length; v++) {
      if (!variants[v].available) continue;
      if (variants[v].options[lockedIndex] !== lockedValue) continue;

      // Score = number of other options that match current selection
      var score = 0;
      for (var o = 0; o < currentOptions.length; o++) {
        if (o === lockedIndex) continue;
        if (variants[v].options[o] === currentOptions[o]) score++;
      }

      if (score > bestScore) {
        bestScore = score;
        bestVariant = variants[v];
      }
    }

    if (bestVariant) {
      activeModal.selectedOptions = bestVariant.options.slice();
    }
  }

  function updateOptionSelection() {
    if (!activeModal) return;

    var buttons = activeModal.el.querySelectorAll('[data-option-value]');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      var idx = parseInt(btn.getAttribute('data-option-index'), 10);
      var val = btn.getAttribute('data-option-value');

      if (val === activeModal.selectedOptions[idx]) {
        btn.classList.add('is-selected');
      } else {
        btn.classList.remove('is-selected');
      }
    }
  }

  function findVariant(options) {
    var variants = activeModal.data.product.variants;
    for (var i = 0; i < variants.length; i++) {
      var match = true;
      for (var j = 0; j < options.length; j++) {
        if (variants[i].options[j] !== options[j]) {
          match = false;
          break;
        }
      }
      if (match) return variants[i];
    }
    return null;
  }

  function updateVariantState() {
    if (!activeModal) return;

    var variant = findVariant(activeModal.selectedOptions);
    var submitBtn = activeModal.el.querySelector('[data-quick-add-submit]');
    var priceEl = activeModal.el.querySelector('[data-quick-add-price]');
    var imageEl = activeModal.el.querySelector('[data-quick-add-image]');
    var errorEl = activeModal.el.querySelector('[data-quick-add-error]');

    if (errorEl) {
      errorEl.hidden = true;
    }

    if (variant) {
      submitBtn.setAttribute('data-variant-id', variant.id);

      if (variant.available) {
        submitBtn.disabled = false;
        // data-label : libellé personnalisé du bouton (ex. popups d'offre panier)
        submitBtn.textContent = submitBtn.getAttribute('data-label') || STRINGS.addToCartButton || 'Ajouter au panier';
      } else {
        submitBtn.disabled = true;
        submitBtn.textContent = STRINGS.soldOutButton || '\u00C9puis\u00E9';
      }

      if (priceEl) {
        var compareEl = priceEl.querySelector('[data-compare-price]');
        var currentEl = priceEl.querySelector('[data-current-price]');

        var taxCoeff = activeModal.data.taxCoefficient || 1;
        // Coefficient de TVA : 1 si la variante n'est pas taxable (ex. ticket tombola)
        if (variant.taxable === false) taxCoeff = 1;
        if (currentEl) currentEl.textContent = formatMoney(Math.round(variant.price * taxCoeff));

        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          if (compareEl) {
            compareEl.textContent = formatMoney(Math.round(variant.compare_at_price * taxCoeff));
            compareEl.style.display = '';
          } else {
            var span = document.createElement('span');
            span.className = 'quick-add-modal__price-compare';
            span.setAttribute('data-compare-price', '');
            span.textContent = formatMoney(Math.round(variant.compare_at_price * taxCoeff));
            priceEl.insertBefore(span, currentEl);
          }
        } else if (compareEl) {
          compareEl.style.display = 'none';
        }
      }

      if (imageEl && variant.featured_image && variant.featured_image.src) {
        if (imageEl.src !== variant.featured_image.src) {
          imageEl.classList.add('is-switching');
          setTimeout(function () {
            imageEl.src = variant.featured_image.src;
            imageEl.alt = variant.featured_image.alt || '';
            imageEl.classList.remove('is-switching');
          }, 150);
        }
      }
    } else {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Indisponible';
    }

    updateOptionAvailability();
  }

  /**
   * 2-level availability check:
   * - Globally available: value exists in at least ONE available variant (any combination)
   * - Available with current selection: value works with the other selected options
   *
   * | Global | Current | Class          | Tooltip | Clickable |
   * |--------|---------|----------------|---------|-----------|
   * | yes    | yes     | (none)         | no      | yes       |
   * | yes    | no      | is-unsellable  | yes     | yes       |
   * | no     | no      | is-disabled    | no      | no        |
   */
  function updateOptionAvailability() {
    if (!activeModal) return;

    var variants = activeModal.data.product.variants;
    var buttons = activeModal.el.querySelectorAll('[data-option-value]');

    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      var optIdx = parseInt(btn.getAttribute('data-option-index'), 10);
      var optVal = btn.getAttribute('data-option-value');

      // Skip the currently selected value for this option — always fully available
      if (optVal === activeModal.selectedOptions[optIdx]) {
        btn.classList.remove('is-unsellable', 'is-disabled');
        continue;
      }

      var globallyAvailable = false;
      var availableWithSelection = false;

      for (var v = 0; v < variants.length; v++) {
        if (variants[v].options[optIdx] !== optVal) continue;
        if (!variants[v].available) continue;

        // This value exists in at least one available variant
        globallyAvailable = true;

        // Check if it also works with the current selection
        var matchesCurrent = true;
        for (var o = 0; o < activeModal.selectedOptions.length; o++) {
          if (o === optIdx) continue;
          if (variants[v].options[o] !== activeModal.selectedOptions[o]) {
            matchesCurrent = false;
            break;
          }
        }
        if (matchesCurrent) {
          availableWithSelection = true;
          break;
        }
      }

      btn.classList.remove('is-unsellable', 'is-disabled');

      if (availableWithSelection) {
        // Fully available — no class needed
      } else if (globallyAvailable) {
        btn.classList.add('is-unsellable');
      } else {
        btn.classList.add('is-disabled');
      }
    }
  }

  /* =====================
     Modal: submit
     ===================== */
  function handleSubmit() {
    if (!activeModal) return;

    var submitBtn = activeModal.el.querySelector('[data-quick-add-submit]');
    var errorEl = activeModal.el.querySelector('[data-quick-add-error]');
    var variantId = parseInt(submitBtn.getAttribute('data-variant-id'), 10);

    if (!variantId || submitBtn.disabled) return;

    if (submitBtn.classList.contains('is-loading') || submitBtn.classList.contains('is-success')) return;

    var buyLimit = (activeModal.data.product.buyLimit || 0);

    submitBtn.classList.add('is-loading');
    if (errorEl) errorEl.hidden = true;

    if (!buyLimit) {
      doModalAdd(submitBtn, errorEl, variantId);
      return;
    }

    // Check cart for buy-limit only
    var productId = activeModal.data.product.id;
    getCart().then(function (cart) {
      var inCartProduct = getCartQuantityForProduct(cart, productId);
      var maxAddable = buyLimit - inCartProduct;

      if (maxAddable <= 0) {
        submitBtn.classList.remove('is-loading');
        showToast(limitReachedMessage(buyLimit), true);
        return;
      }

      doModalAdd(submitBtn, errorEl, variantId);
    }).catch(function () {
      doModalAdd(submitBtn, errorEl, variantId);
    });
  }

  function doModalAdd(submitBtn, errorEl, variantId) {
    addToCart(variantId)
      .then(function () {
        submitBtn.classList.remove('is-loading');
        submitBtn.classList.add('is-success');
        submitBtn.textContent = '\u2713';
        notifyCartChange();
        showToast(TOAST_ADDED + ' \u2713');

        setTimeout(function () {
          closeModal();
        }, 500);
      })
      .catch(function (err) {
        submitBtn.classList.remove('is-loading');
        if (errorEl) {
          errorEl.textContent = err.message;
          errorEl.hidden = false;
        }
      });
  }

  /* =====================
     Event delegation
     ===================== */
  document.addEventListener('click', function (e) {
    // Trigger button (direct add or modal open)
    var trigger = e.target.closest('[data-quick-add-trigger]');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();

      if (trigger.hasAttribute('data-quick-add-variant-id')) {
        handleDirectAdd(trigger);
      } else if (trigger.hasAttribute('data-quick-add-product-id')) {
        openModal(trigger);
      }
      return;
    }

    // Close button
    if (e.target.closest('[data-quick-add-close]')) {
      e.preventDefault();
      closeModal();
      return;
    }

    // Backdrop click: click on the <dialog> element itself (outside panel)
    if (activeModal && e.target === activeModal.el) {
      var panel = activeModal.el.querySelector('.overlay-drawer__panel');
      if (panel) {
        var rect = panel.getBoundingClientRect();
        var inside = e.clientX >= rect.left && e.clientX <= rect.right &&
                     e.clientY >= rect.top && e.clientY <= rect.bottom;
        if (!inside) {
          closeModal();
          return;
        }
      }
    }

    // Option value button
    var optionBtn = e.target.closest('[data-option-value]');
    if (optionBtn && activeModal && activeModal.el.contains(optionBtn)) {
      e.preventDefault();
      handleOptionClick(optionBtn);
      return;
    }

    // Submit button
    if (e.target.closest('[data-quick-add-submit]')) {
      e.preventDefault();
      handleSubmit();
      return;
    }
  });

  // Intercept Escape to play closing animation (native dialog closes immediately)
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && activeModal) {
      e.preventDefault();
      closeModal();
    }
  });
})();
